<template>
  <div class="rounded-t-none rounded-lg bg-gray-700 pb-2">
    <ul>
      <li
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[orderedBy === 'numbers' ? 'bg-white text-gray-700' : 'bg-gray-700']"
        @click="
          setOrderedBy({ orderedBy: 'numbers' })
          $emit('closeMenu')
        "
      >
        <img
          v-if="orderedBy === 'numbers'"
          class="h-6 mr-3 cursor-pointer"
          src="../../assets/icons/numbersOrderOn.svg"
          alt="Tri par numéro"
        />
        <img v-else class="h-6 mr-3 cursor-pointer" src="../../assets/icons/numbersOrderOff.svg" alt="Tri par numéro" />
        Par numéro
      </li>
      <li
        class="flex h-14 items-center w-full p-3 cursor-pointer select-none"
        :class="[orderedBy === 'likes' ? 'bg-white text-gray-700' : 'bg-gray-800']"
        @click="
          setOrderedBy({ orderedBy: 'likes' })
          $emit('closeMenu')
        "
      >
        <img
          v-if="orderedBy === 'likes'"
          class="h-6 mr-3 cursor-pointer"
          src="../../assets/icons/likesOrderOn.svg"
          alt="Tri par like"
        />
        <img v-else class="h-6 mr-3 cursor-pointer" src="../../assets/icons/likesOrderOff.svg" alt="Tri par like" />
        Par popularité
      </li>
      <li
        v-if="hasLabels && gridMode !== 'label' && (gridMode !== 'group' || hasGroups === false)"
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[orderedBy === 'labels' ? 'bg-white text-gray-700' : 'bg-gray-700']"
        @click="
          setOrderedBy({ orderedBy: 'labels', labelGuidsOrdered: getGuidsOrdered })
          $emit('closeMenu')
        "
      >
        <div class="w-6 mr-3">
          <img
            v-if="orderedBy === 'labels'"
            class="cursor-pointer"
            src="../../assets/icons/labelsOrderOn.svg"
            alt="Tri par label"
          />
          <img v-else class="cursor-pointer" src="../../assets/icons/labelsOrderOff.svg" alt="Tri par label" />
        </div>
        Par Label
      </li>
      <li
        v-if="hasLabels && gridMode !== 'label' && (gridMode !== 'group' || hasGroups === false)"
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[orderedBy === 'labelsNumbers' ? 'bg-white text-gray-700' : 'bg-gray-800']"
        @click="
          setOrderedBy({ orderedBy: 'labelsNumbers', labelGuidsOrdered: getGuidsOrdered })
          $emit('closeMenu')
        "
      >
        <div class="w-6 mr-3">
          <img
            v-if="orderedBy === 'labelsNumbers'"
            class="cursor-pointer"
            src="../../assets/icons/labelsNumbersOrderOn.svg"
            alt="Tri par label et numéro"
          />
          <img
            v-else
            class="cursor-pointer"
            src="../../assets/icons/labelsNumbersOrderOff.svg"
            alt="Tri par label et numéro"
          />
        </div>
        Par Label et numéro
      </li>
      <li
        v-if="hasLabels && gridMode !== 'label' && (gridMode !== 'group' || hasGroups === false)"
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[orderedBy === 'labelsLikes' ? 'bg-white text-gray-700' : 'bg-gray-700']"
        @click="
          setOrderedBy({ orderedBy: 'labelsLikes', labelGuidsOrdered: getGuidsOrdered })
          $emit('closeMenu')
        "
      >
        <div class="w-6 mr-3">
          <img
            v-if="orderedBy === 'labelsLikes'"
            class="cursor-pointer"
            src="../../assets/icons/labelsLikesOrderOn.svg"
            alt="Tri par label et popularité"
          />
          <img
            v-else
            class="cursor-pointer"
            src="../../assets/icons/labelsLikesOrderOff.svg"
            alt="Tri par label et popularité"
          />
        </div>
        Par Label et popularité
      </li>

      <li
        v-if="gridMode !== 'label'"
        class="flex h-14 items-center p-3 cursor-pointer select-none"
        :class="[
          orderedBy === 'reorder'
            ? 'bg-white text-gray-700'
            : hasLabels && gridMode !== 'label' && gridMode !== 'group'
            ? 'bg-gray-800'
            : 'bg-gray-700',
        ]"
        @click="
          setOrderedBy({ orderedBy: 'reorder' })
          $emit('closeMenu')
        "
      >
        <img
          v-if="orderedBy === 'reorder'"
          class="h-6 mr-3 cursor-pointer"
          src="../../assets/icons/reorderOn.svg"
          alt="Re-numéroter"
        />
        <img v-else class="h-6 mr-3 cursor-pointer" src="../../assets/icons/reorderOff.svg" alt="Re-numéroter" />
        Re-numéroter
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex"

export default {
  computed: {
    ...mapState({
      orderedBy: (state) => state.grid.orderedBy,
      gridMode: (state) => state.grid.gridMode,
    }),
    ...mapGetters("labels", ["hasLabels", "getGuidsOrdered"]),
    ...mapGetters("answers", ["hasGroups"]),
  },
  methods: {
    ...mapMutations("grid", ["setOrderedBy"]),
  },
}
</script>

<style></style>
